export default __webpack_public_path__ + "static/media/logo.628ffc8f.png";